import TimelineTabsComponent from "./timeline-tabs-component";
import TimelineTabsConfig from "./timeline-tabs-config";
import TimelineTabsAdvancedConfig from "./timeline-tabs-advanced-config";

export default {
  TimelineTabsComponent,
  TimelineTabsConfig,
  TimelineTabsAdvancedConfig
};
